import { RepositoryFactory } from "@/Apicall/RepositoryFactory";
const category = RepositoryFactory.get("portfolioCategory");

export default {
  create({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await category.create(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  get({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await category.get(payload);
        commit("SET_CATEGORY", data.data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  update({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await category.update(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  delete({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await category.delete(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
